<template>
  <v-flex>
    <div
      v-for="thread in sortedList"
      :key="thread.thread.id"
    >
      <div
        class="thread-con"
        :class="{ 'active': thread.thread.id === (selectedThread ? selectedThread.thread.id : '') }"
        @click="setThread(thread)"
      >
        <div class="thread">
          <div
            class="thread__title-header"
            :style="{ color: getThreadColor(thread.thread.type) }"
          >
            {{ thread.thread.subject }}
            <span class="time">
              {{ getThreadLastMessageTime(
                thread.messages[thread.messages.length - 1]._timestamp) }}
            </span>
          </div>
          <p v-if="thread.thread.subtitle" class="thread__subtitle">
            {{ thread.thread.subtitle }}
          </p>
        </div>
      </div>
      <v-divider />
    </div>
  </v-flex>
</template>

<script>
import moment from 'moment'
import getThreadColorMixin from '../mixins/getThreadColorsMixin'
import { mapState, mapMutations } from 'vuex'
export default {
  mixins: [getThreadColorMixin],
  props: {
    list: {
      type: Array,
      default: () => [{}]
    },
    sortTypes: {
      type: Array,
      default: () => ([])
    },
    sortDate: {
      type: Boolean,
      default: false
    },
    sender: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState('communication', ['selectedThread']),
    sortedList() {
      let list = this.list
        .filter(item => item.thread && this.sortTypes.includes(item.thread.type))
        .filter(item => {
          if (typeof item.thread.isShownForSender === 'boolean' && item.thread.isShownForSender === false) {
            return item.messages[0].from !== this.sender._id
          } else return true
        })
      list.sort((a, b) =>
        (new Date(b.messages[b.messages.length - 1]._timestamp) -
          new Date(a.messages[a.messages.length - 1]._timestamp))
      )
      if (this.sortDate) {
        return list.reverse()
      }
      return list
    }
  },
  methods: {
    ...mapMutations('communication', {
      selectThread: 'SET_THREAD'
    }),
    ...mapMutations('mobile', {
      setShowingMobileBackButton: 'SET_SHOWING_MOBILE_BACK_BUTTON'
    }),
    setThread(thread) {
      this.selectThread(thread)
      this.setShowingMobileBackButton(true)
    },
    getThreadLastMessageTime(time) {
      return moment(time).fromNow(true)
    }
  }
}
</script>

<style lang="sass" scoped>
.time
  color: gray !important
  font-size: 1rem
  width: 55px
  text-align: right
</style>

<style lang="sass">
.filtered-message-list
  width: 100%
  font-size: 14px
  padding: 0 1rem
  background-color: #fff
  v-divider
    width: 100%
.thread
  flex: 1
  text-align: left
  &__subtitle
    font-size: 12px
    padding-left: 8px
    max-width: 200px
    text-overflow: ellipsis
    white-space: nowrap
    overflow: hidden
  &__title-header
    display: flex
    justify-content: space-between
.thread-con
  cursor: pointer
  min-height: 4rem
  display: flex
  padding: 0.5rem
  &:hover
   background: rgba(0,0,0,0.12)
.thread-con.active
  background: rgba(0,0,0,0.12)
</style>
